import { pickBy } from '../../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import { TyreIndex } from './filter_sections/tyre_index';
import { Brand } from './filter_sections/brand';
import { Vehicle } from './filter_sections/vehicle';
import { Price } from './filter_sections/price';
import { Deals } from './filter_sections/deals';
import { QualitySegment } from './filter_sections/quality_segment';
import { Features } from './filter_sections/features';
import { Additional } from './filter_sections/additional';
import Translation from '../../translation/translation';
import { FilterSections } from '../../../constants/filter/filter_sections';
import { Filters } from '../../../constants/filter/filters';
import { getDefaultValueForFilter } from '../../../helper/filters/get_default_value_for_filter';
import { featureFlags } from '../../../../_constants/feature_flags';
import { Usage } from './filter_sections/usage';
import { Technology } from './filter_sections/technology';
import { TyreRatings } from './filter_sections/tyre_ratings';
import { CustomerReviews } from './filter_sections/customer_reviews';
import { Season } from './filter_sections/season';
import { Ev } from './filter_sections/ev';
import { hideFiltersAction } from '../../../actions/catalog_filter_view_actions';

function checkIfAtLeastOneFilterHasAValue(allFilters, filtersToCheck) {
  return (
    Object.keys(
      pickBy(allFilters, (filterValue, filterName) => {
        return filtersToCheck.indexOf(filterName) !== -1 && filterValue !== getDefaultValueForFilter(filterName);
      }),
    ).length !== 0
  );
}

function Tyre(props) {
  const sectionVisibility = props.sectionVisibility;
  const filterValues = props.filterValues;
  const filterOptions = props.filterOptions;
  const availableFilterOptions = props.availableFilterOptions;
  const onActionClick = props.onActionClick;
  let tyreSizeValues =
    (filterValues[Filters.WIDTH] || 0) +
    '|' +
    (filterValues[Filters.HEIGHT] || 0) +
    '|' +
    (filterValues[Filters.DIAMETER] || 0);
  const customerReviewsEnabled = TYROOLA.initialFluxStates?.catalogFilter?.customerReviewsEnabled || false;

  return (
    <>
      {props.visible && <div className="catalog-overlay" onClick={() => hideFiltersAction()}></div>}
      {props.visible && (
        <div className="catalog-filter-column" style={{ display: props.visible ? 'block' : 'none' }}>
          <Vehicle
            tyreSizeValues={tyreSizeValues}
            resettable={1 !== 2}
            onVehicleTyreChange={props.onVehicleTyreChange}
            onRegoLookupEdit={props.onRegoLookupEdit}
            onVehicleSelectorEdit={props.onVehicleSelectorEdit}
            onShowVehicleInfo={props.onShowVehicleInfo}
          />
          <Translation
            translationKey="catalog-filters-section-headline"
            tagName="h2"
            className="catalog-filter-column__headline"
          />
          <div className="catalog-filter-column__filters-section catalog-filters-section">
            <TyreIndex
              speedIndexValue={filterValues[Filters.SPEED_INDEX]}
              loadIndexValue={filterValues[Filters.LOAD_INDEX]}
              speedIndexOptions={filterOptions[Filters.SPEED_INDEX]}
              loadIndexOptions={filterOptions[Filters.LOAD_INDEX]}
              opened={sectionVisibility[FilterSections.TYRE_INDEX_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.LOAD_INDEX, Filters.SPEED_INDEX])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.TYRE_INDEX_VIEW)}
              onToolTipHover={props.onToolTipHover}
              onLoadIndexChange={props.onChangeCallback}
              onSpeedIndexChange={props.onChangeCallback}
              availableSpeedIndexOptions={availableFilterOptions[Filters.SPEED_INDEX]}
              availableLoadIndexOptions={availableFilterOptions[Filters.LOAD_INDEX]}
            />

            <Brand
              brandValue={filterValues[Filters.MANUFACTURER]}
              modelValue={filterValues[Filters.MODEL]}
              brandOptions={filterOptions[Filters.MANUFACTURER]}
              modelOptions={filterOptions[Filters.MODEL]}
              modelOptionsLoading={filterOptions[Filters.MODEL + 'Loading']}
              opened={sectionVisibility[FilterSections.BRAND_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.MANUFACTURER, Filters.MODEL])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.BRAND_VIEW)}
              onToolTipHover={props.onToolTipHover}
              onBrandChange={props.onChangeCallback}
              onModelChange={props.onChangeCallback}
            />

            <Price
              minPriceValue={filterValues[Filters.PRICE_MIN].toString()}
              maxPriceValue={filterValues[Filters.PRICE_MAX].toString()}
              minPriceOptions={filterOptions[Filters.PRICE_MIN]}
              maxPriceOptions={filterOptions[Filters.PRICE_MAX]}
              opened={sectionVisibility[FilterSections.PRICE_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.PRICE_MIN, Filters.PRICE_MAX])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.PRICE_VIEW)}
              onMinPriceChange={props.onChangeCallback}
              onMaxPriceChange={props.onChangeCallback}
              currencyIsoCode={props.currencyIsoCode}
              onToolTipHover={props.onToolTipHover}
            />

            {featureFlags.FEATURE_TYRE_DEALS && (
              <Deals
                freeFittingEnabled={props.conditionalFilters[Filters.FREE_FITTING]}
                buy4Pay3Enabled={props.conditionalFilters[Filters.BUY_4_PAY_3]}
                clearanceEnabled={props.conditionalFilters[Filters.CLEARANCE]}
                instantCashEnabled={props.conditionalFilters[Filters.INSTANT_CASH]}
                discountInstantCash50Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_50]}
                discountInstantCash80Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_80]}
                discountInstantCash100Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_100]}
                discountInstantCash120Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_120]}
                discountInstantCash150Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_150]}
                discountInstantCash160Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_160]}
                discountInstantCash200Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_200]}
                discountInstantCash250Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_250]}
                discountInstantCash300Enabled={props.conditionalFilters[Filters.DISCOUNT_INSTANT_CASH_300]}
                discount5OffEnabled={props.conditionalFilters[Filters.DISCOUNT_5_OFF]}
                discount10OffEnabled={props.conditionalFilters[Filters.DISCOUNT_10_OFF]}
                discount15OffEnabled={props.conditionalFilters[Filters.DISCOUNT_15_OFF]}
                discount20OffEnabled={props.conditionalFilters[Filters.DISCOUNT_20_OFF]}
                discount25OffEnabled={props.conditionalFilters[Filters.DISCOUNT_25_OFF]}
                promoGiftCard50Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_50]}
                promoGiftCard80Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_80]}
                promoGiftCard100Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_100]}
                promoGiftCard130Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_130]}
                promoGiftCard150Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_150]}
                promoGiftCard200Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_200]}
                promoGiftCard250Enabled={props.conditionalFilters[Filters.PROMO_GIFT_CARD_250]}
                freeFittingValue={getDefaultValueForFilter(Filters.FREE_FITTING) !== filterValues[Filters.FREE_FITTING]}
                buy4Pay3Value={getDefaultValueForFilter(Filters.BUY_4_PAY_3) !== filterValues[Filters.BUY_4_PAY_3]}
                clearanceValue={getDefaultValueForFilter(Filters.CLEARANCE) !== filterValues[Filters.CLEARANCE]}
                instantCashValue={getDefaultValueForFilter(Filters.INSTANT_CASH) !== filterValues[Filters.INSTANT_CASH]}
                discountInstantCash50Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_50) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_50]
                }
                discountInstantCash80Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_80) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_80]
                }
                discountInstantCash100Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_100) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_100]
                }
                discountInstantCash120Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_120) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_120]
                }
                discountInstantCash150Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_150) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_150]
                }
                discountInstantCash160Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_160) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_160]
                }
                discountInstantCash200Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_200) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_200]
                }
                discountInstantCash250Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_250) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_250]
                }
                discountInstantCash300Value={
                  getDefaultValueForFilter(Filters.DISCOUNT_INSTANT_CASH_300) !==
                  filterValues[Filters.DISCOUNT_INSTANT_CASH_300]
                }
                discount5OffValue={
                  getDefaultValueForFilter(Filters.DISCOUNT_5_OFF) !== filterValues[Filters.DISCOUNT_5_OFF]
                }
                discount10OffValue={
                  getDefaultValueForFilter(Filters.DISCOUNT_10_OFF) !== filterValues[Filters.DISCOUNT_10_OFF]
                }
                discount15OffValue={
                  getDefaultValueForFilter(Filters.DISCOUNT_15_OFF) !== filterValues[Filters.DISCOUNT_15_OFF]
                }
                discount20OffValue={
                  getDefaultValueForFilter(Filters.DISCOUNT_20_OFF) !== filterValues[Filters.DISCOUNT_20_OFF]
                }
                discount25OffValue={
                    getDefaultValueForFilter(Filters.DISCOUNT_25_OFF) !== filterValues[Filters.DISCOUNT_25_OFF]
                }
                promoGiftCard50Value={
                    getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_50) !== filterValues[Filters.PROMO_GIFT_CARD_50]
                }
                promoGiftCard80Value={
                    getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_80) !== filterValues[Filters.PROMO_GIFT_CARD_80]
                }
                promoGiftCard100Value={
                    getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_100) !== filterValues[Filters.PROMO_GIFT_CARD_100]
                }
                promoGiftCard130Value={
                    getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_130) !== filterValues[Filters.PROMO_GIFT_CARD_130]
                }
                promoGiftCard150Value={
                    getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_150) !== filterValues[Filters.PROMO_GIFT_CARD_150]
                }
                promoGiftCard200Value={
                    getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_200) !== filterValues[Filters.PROMO_GIFT_CARD_200]
                }
                promoGiftCard250Value={
                    getDefaultValueForFilter(Filters.PROMO_GIFT_CARD_250) !== filterValues[Filters.PROMO_GIFT_CARD_250]
                }
                opened={sectionVisibility[FilterSections.DEALS_VIEW]}
                resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [
                  Filters.FREE_FITTING,
                  Filters.BUY_4_PAY_3,
                  Filters.CLEARANCE,
                  //Filters.INSTANT_CASH
                  Filters.DISCOUNT_INSTANT_CASH_50,
                  Filters.DISCOUNT_INSTANT_CASH_80,
                  Filters.DISCOUNT_INSTANT_CASH_100,
                  Filters.DISCOUNT_INSTANT_CASH_120,
                  Filters.DISCOUNT_INSTANT_CASH_150,
                  Filters.DISCOUNT_INSTANT_CASH_160,
                  Filters.DISCOUNT_INSTANT_CASH_200,
                  Filters.DISCOUNT_INSTANT_CASH_250,
                  Filters.DISCOUNT_INSTANT_CASH_300,
                  Filters.DISCOUNT_5_OFF,
                  Filters.DISCOUNT_10_OFF,
                  Filters.DISCOUNT_15_OFF,
                  Filters.DISCOUNT_20_OFF,
                  Filters.DISCOUNT_25_OFF,
                  Filters.PROMO_GIFT_CARD_50,
                  Filters.PROMO_GIFT_CARD_80,
                  Filters.PROMO_GIFT_CARD_100,
                  Filters.PROMO_GIFT_CARD_130,
                  Filters.PROMO_GIFT_CARD_150,
                  Filters.PROMO_GIFT_CARD_200,
                  Filters.PROMO_GIFT_CARD_250,
                ])}
                onActionClick={(evt) => onActionClick(evt, FilterSections.DEALS_VIEW)}
                onToolTipHover={props.onToolTipHover}
                onFreeFittingChange={props.onChangeCallback}
                onBuy4Pay3Change={props.onChangeCallback}
                onClearanceChange={props.onChangeCallback}
                onInstantCashChange={props.onChangeCallback}
              />
            )}

            <Features
              runflatEnabled={props.conditionalFilters[Filters.RUN_FLAT]}
              runflatValue={getDefaultValueForFilter(Filters.RUN_FLAT) !== filterValues[Filters.RUN_FLAT]}
              onRunflatChange={props.onChangeCallback}
              opened={sectionVisibility[FilterSections.FEATURES_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.RUN_FLAT])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.FEATURES_VIEW)}
              onToolTipHover={props.onToolTipHover}
            />

            <QualitySegment
              qualitySegmentPremiumEnabled={props.conditionalFilters[Filters.QUALITY_SEGMENT_PREMIUM]}
              qualitySegmentValueEnabled={props.conditionalFilters[Filters.QUALITY_SEGMENT_VALUE]}
              qualitySegmentBudgetEnabled={props.conditionalFilters[Filters.QUALITY_SEGMENT_BUDGET]}
              qualitySegmentPremiumValue={
                getDefaultValueForFilter(Filters.QUALITY_SEGMENT_PREMIUM) !==
                filterValues[Filters.QUALITY_SEGMENT_PREMIUM]
              }
              qualitySegmentValueValue={
                getDefaultValueForFilter(Filters.QUALITY_SEGMENT_VALUE) !== filterValues[Filters.QUALITY_SEGMENT_VALUE]
              }
              qualitySegmentBudgetValue={
                getDefaultValueForFilter(Filters.QUALITY_SEGMENT_BUDGET) !==
                filterValues[Filters.QUALITY_SEGMENT_BUDGET]
              }
              opened={sectionVisibility[FilterSections.QUALITY_SEGMENT_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [
                Filters.QUALITY_SEGMENT_PREMIUM,
                Filters.QUALITY_SEGMENT_VALUE,
                Filters.QUALITY_SEGMENT_BUDGET,
              ])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.QUALITY_SEGMENT_VIEW)}
              onToolTipHover={props.onToolTipHover}
              onQualitySegmentChange={props.onChangeCallback}
            />

            {customerReviewsEnabled && (
              <>
                <CustomerReviews
                  opened={sectionVisibility[FilterSections.CUSTOMER_REVIEWS_VIEW]}
                  resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [
                    Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP,
                    Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP,
                    Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP,
                    Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP,
                    Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP,
                    Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP,
                    Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP,
                  ])}
                  onActionClick={(evt) => onActionClick(evt, FilterSections.CUSTOMER_REVIEWS_VIEW)}
                  onToolTipHover={props.onToolTipHover}
                  customerReviewDryTractionRatingAvgGroupValue={filterValues[
                    Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP
                  ].toString()}
                  customerReviewDryTractionRatingAvgGroupOptions={
                    filterOptions[Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]
                  }
                  onCustomerReviewDryTractionRatingAvgGroupChange={props.onChangeCallback}
                  customerReviewLowNoiseRatingAvgGroupValue={filterValues[
                    Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP
                  ].toString()}
                  customerReviewLowNoiseRatingAvgGroupOptions={
                    filterOptions[Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]
                  }
                  onCustomerReviewLowNoiseRatingAvgGroupChange={props.onChangeCallback}
                  customerReviewRideComfortRatingAvgGroupValue={filterValues[
                    Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP
                  ].toString()}
                  customerReviewRideComfortRatingAvgGroupOptions={
                    filterOptions[Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]
                  }
                  onCustomerReviewRideComfortRatingAvgGroupChange={props.onChangeCallback}
                  customerReviewSteeringResponseAvgGroupValue={filterValues[
                    Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP
                  ].toString()}
                  customerReviewSteeringResponseAvgGroupOptions={
                    filterOptions[Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]
                  }
                  onCustomerReviewSteeringResponseAvgGroupChange={props.onChangeCallback}
                  customerReviewTreadWearAvgGroupValue={filterValues[
                    Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP
                  ].toString()}
                  customerReviewTreadWearAvgGroupOptions={
                    filterOptions[Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]
                  }
                  onCustomerReviewTreadWearAvgGroupChange={props.onChangeCallback}
                  customerReviewValueForMoneyAvgGroupValue={filterValues[
                    Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP
                  ].toString()}
                  customerReviewValueForMoneyAvgGroupOptions={
                    filterOptions[Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]
                  }
                  onCustomerReviewValueForMoneyAvgGroupChange={props.onChangeCallback}
                  customerReviewWetTractionRatingAvgGroupValue={filterValues[
                    Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP
                  ].toString()}
                  customerReviewWetTractionRatingAvgGroupOptions={
                    filterOptions[Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]
                  }
                  onCustomerReviewWetTractionRatingAvgGroupChange={props.onChangeCallback}
                />
              </>
            )}

            <TyreRatings
              opened={sectionVisibility[FilterSections.TYRE_RATINGS_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [
                Filters.UTQG_TREADWEAR_GROUP,
                Filters.UTQG_TRACTION,
                Filters.UTQG_TEMPERATURE,
                Filters.UTQG_TREADWEAR_GROUP,
                Filters.UTQG_TRACTION,
                Filters.UTQG_TEMPERATURE,
                Filters.LABEL_NOISE,
                Filters.LABEL_WET_GRIP,
                Filters.LABEL_FUEL_EFFICIENCY,
              ])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.TYRE_RATINGS_VIEW)}
              onToolTipHover={props.onToolTipHover}
              utqgTreadwearGroupValue={filterValues[Filters.UTQG_TREADWEAR_GROUP].toString()}
              utqgTreadwearGroupOptions={filterOptions[Filters.UTQG_TREADWEAR_GROUP]}
              onUtqgTreadwearGroupChange={props.onChangeCallback}
              utqgTractionValue={filterValues[Filters.UTQG_TRACTION]}
              utqgTractionOptions={filterOptions[Filters.UTQG_TRACTION]}
              onUtqgTractionChange={props.onChangeCallback}
              utqgTemperatureValue={filterValues[Filters.UTQG_TEMPERATURE]}
              utqgTemperatureOptions={filterOptions[Filters.UTQG_TEMPERATURE]}
              onUtqgTemperatureChange={props.onChangeCallback}
              labelNoiseValue={filterValues[Filters.LABEL_NOISE].toString()}
              labelNoiseOptions={filterOptions[Filters.LABEL_NOISE]}
              onLabelNoiseChange={props.onChangeCallback}
              labelWetGripValue={filterValues[Filters.LABEL_WET_GRIP]}
              labelWetGripOptions={filterOptions[Filters.LABEL_WET_GRIP]}
              onLabelWetGripChange={props.onChangeCallback}
              labelFuelEfficiencyValue={filterValues[Filters.LABEL_FUEL_EFFICIENCY]}
              labelFuelEfficiencyOptions={filterOptions[Filters.LABEL_FUEL_EFFICIENCY]}
              onLabelFuelEfficiencyChange={props.onChangeCallback}
            />

            <Season
              seasonValue={filterValues[Filters.SEASON]}
              seasonOptions={filterOptions[Filters.SEASON]}
              opened={sectionVisibility[FilterSections.SEASON_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.SEASON])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.SEASON_VIEW)}
              onSeasonChange={props.onChangeCallback}
              onToolTipHover={props.onToolTipHover}
            />

            <Ev
              evValue={filterValues[Filters.EV]}
              evOptions={filterOptions[Filters.EV]}
              opened={sectionVisibility[FilterSections.EV_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.EV])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.EV_VIEW)}
              onEvChange={props.onChangeCallback}
              onToolTipHover={props.onToolTipHover}
            />

            <Technology
              technologyValue={filterValues[Filters.TECHNOLOGY]}
              technologyOptions={filterOptions[Filters.TECHNOLOGY]}
              opened={sectionVisibility[FilterSections.TECHNOLOGY_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.TECHNOLOGY])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.TECHNOLOGY_VIEW)}
              onTechnologyChange={props.onChangeCallback}
              onToolTipHover={props.onToolTipHover}
            />

            <Usage
              usageValue={filterValues[Filters.USAGE]}
              usageOptions={filterOptions[Filters.USAGE]}
              opened={sectionVisibility[FilterSections.USAGE_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.USAGE])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.USAGE_VIEW)}
              onUsageChange={props.onChangeCallback}
              onToolTipHover={props.onToolTipHover}
            />

            <Additional
              vehicleTypeValue={filterValues[Filters.VEHICLE_TYPE]}
              vehicleTypeOptions={filterOptions[Filters.VEHICLE_TYPE]}
              opened={sectionVisibility[FilterSections.ADDITIONAL_VIEW]}
              resettable={checkIfAtLeastOneFilterHasAValue(filterValues, [Filters.VEHICLE_TYPE])}
              onActionClick={(evt) => onActionClick(evt, FilterSections.ADDITIONAL_VIEW)}
              onVehicleTypeChange={props.onChangeCallback}
              onToolTipHover={props.onToolTipHover}
            />
          </div>
        </div>
      )}
    </>
  );
}

Tyre.propTypes = {
  currencyIsoCode: PropTypes.string.isRequired,
  sectionVisibility: PropTypes.object.isRequired,
  filterValues: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired,
  availableFilterOptions: PropTypes.object.isRequired,
  conditionalFilters: PropTypes.object.isRequired,
  onActionClick: PropTypes.func.isRequired,
  onToolTipHover: PropTypes.func.isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  onVehicleTyreChange: PropTypes.func.isRequired,
  onRegoLookupEdit: PropTypes.func.isRequired,
  onVehicleSelectorEdit: PropTypes.func.isRequired,
  lastUsedConfigurator: PropTypes.string.isRequired,
  onShowVehicleInfo: PropTypes.func.isRequired,
};

export { Tyre };
